import { request } from '@/shared/api/request'

export const getTransferDetail = (bin, isLocal = true) =>
	request({ url: `/contract/universalMethods/transfert/data?bin=${bin}&isLocal=${isLocal}`, method: 'GET' })
